(function () {
  // Fine-pointer only (mouse/trackpad). Touch devices keep native UX.
  if (!window.matchMedia('(pointer: fine)').matches) return;

  // Bail in theme editor so Shopify admin cursor works normally.
  if (window.Shopify && window.Shopify.designMode) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Lerp factor: 1 = snap immediately (reduced motion), 0.18 = fluid chase
  var LERP = reducedMotion ? 1 : 0.18;

  // Clickable targets — matches user spec exactly
  var CLICKABLE = 'a, button, input[type="submit"], input[type="button"], [role="button"], .pill, .header__icon';

  var el = document.createElement('div');
  el.id = 'sr-cursor';
  el.setAttribute('aria-hidden', 'true');
  document.body.appendChild(el);

  // Target position (actual mouse) and current chased position
  var tx = -200, ty = -200;
  var cx = -200, cy = -200;

  var visible = false;
  var hovering = false;
  var pressed = false;

  function sync() {
    el.classList.toggle('is-visible', visible);
    el.classList.toggle('is-hovering', hovering);
    el.classList.toggle('is-pressed', pressed);
  }

  function tick() {
    cx += (tx - cx) * LERP;
    cy += (ty - cy) * LERP;
    el.style.setProperty('--cx', cx.toFixed(1) + 'px');
    el.style.setProperty('--cy', cy.toFixed(1) + 'px');
    requestAnimationFrame(tick);
  }

  // pointermove covers mouse + pen; filter to mouse only so touch doesn't fire
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    tx = e.clientX;
    ty = e.clientY;

    if (!visible) {
      // Snap to mouse on first appearance so the dot doesn't fly in from off-screen
      cx = tx;
      cy = ty;
      el.style.setProperty('--cx', cx + 'px');
      el.style.setProperty('--cy', cy + 'px');
      visible = true;
    }

    var t = e.target;
    hovering = !!(t && t.closest && t.closest(CLICKABLE));
    sync();
  });

  document.addEventListener('mouseleave', function () {
    visible = false;
    sync();
  });

  document.addEventListener('mouseenter', function () {
    visible = true;
    sync();
  });

  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return; // left-click only
    pressed = true;
    sync();
  });

  document.addEventListener('mouseup', function () {
    pressed = false;
    sync();
  });

  /* ---------- v3 §2 — apps that render in the browser's top layer ---------
     The dot already carries the maximum z-index and pointer-events:none, and
     that is enough for every ordinary overlay — verified over the cart drawer
     and the cookie banner, where it draws fine.

     It is not enough for a <dialog> opened with showModal() or a popover: the
     top layer paints above every z-index there is, by specification, so no
     number wins. Shopify Forms (the SMS popup) is one of those, which is why
     the dot vanished there while still tracking underneath.

     So for as long as one is open the native cursor comes back. The visitor is
     never left clicking blind, and nothing else on the page is affected — the
     theme itself uses no native dialogs. */
  var nativeCursor = false;
  var queued = false;

  function modalOpen() {
    if (document.querySelector('dialog[open]')) return true;
    // :popover-open is recent enough that older engines throw on the selector.
    try {
      if (document.querySelector('[popover]:popover-open')) return true;
    } catch (err) {
      /* selector unsupported — dialogs alone are the common case */
    }
    return false;
  }

  function syncNativeCursor() {
    queued = false;
    var open = modalOpen();
    if (open === nativeCursor) return;
    nativeCursor = open;
    document.documentElement.classList.toggle('sr-native-cursor', open);
  }

  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(syncNativeCursor);
  }

  // childList catches the popup being mounted; the attribute filter catches a
  // dialog that is already in the DOM being opened. One query per frame at
  // most, so a chatty app cannot turn this into a scroll-jank machine.
  new MutationObserver(queueSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'popover'],
  });

  syncNativeCursor();

  // Kick off the rAF loop — one loop, runs forever, no per-frame DOM queries
  requestAnimationFrame(tick);
})();
